// extracted by mini-css-extract-plugin
export var aggregationCell = "_2m-n";
export var aggregationRow = "_2m-m";
export var borderlessSpinnerContainer = "_2m-3";
export var cardLayout = "_2m-6";
export var cardLayoutNoFooter = "_2m-9";
export var cardLayoutPageControl = "_2m-8";
export var closeIcon = "_2m-f";
export var columnHeaderSurface = "_2m-b";
export var columnHeaderSurfaceDragOverlay = "_2m-v";
export var columnHeaderSurfaceResizing = "_2m-s";
export var contextMenuAnchor = "_2m-1";
export var draggableColumnHeader = "_2m-t";
export var draggableColumnHeaderOverlay = "_2m-u";
export var expandIcon = "_2m-g";
export var expanded = "_2m-h";
export var filterDropdown = "_2m-i";
export var filterDropdownDivider = "_2m-d";
export var filterDropdownHeader = "_2m-l";
export var filterDropdownItem = "_2m-k";
export var filterDropdownModal = "_2m-j _2m-i";
export var filterItem = "_2m-c";
export var normalCellWithAdjustableBorder = "_2m-e";
export var pinButtonContainer = "_2m-o";
export var pinIcon = "_2m-p";
export var pinIconActive = "_2m-q";
export var spinner = "_2m-0";
export var spinnerContainer = "_2m-2";
export var tableContainer = "_2m-4";
export var tableContentDraggingColumns = "_2m-a";
export var tableContentInner = "_2m-7";
export var tableContentWrapper = "_2m-5";
export var viewButtonContainer = "_2m-r";